<script>
// Um campo personalizado do negócio, desenhado conforme o tipo cadastrado em
// Configurações > Atributos. Vive fora da gaveta porque a mesma marcação serve
// pros campos sempre visíveis e pros que ficam no expansor "Mais campos".
export default {
  name: 'DealCustomField',
  props: {
    definition: { type: Object, required: true },
    value: { type: [String, Number, Boolean], default: '' },
  },
  emits: ['change'],
  computed: {
    type() {
      return this.definition.attribute_display_type;
    },
    // <input type="date"> só aceita AAAA-MM-DD; o gravado pode ter hora junto.
    dateValue() {
      return String(this.value ?? '').slice(0, 10);
    },
    inputType() {
      return this.type === 'number' ? 'number' : 'text';
    },
  },
  methods: {
    onChange(event) {
      const raw =
        this.type === 'checkbox' ? event.target.checked : event.target.value;
      this.$emit('change', { key: this.definition.attribute_key, value: raw });
    },
  },
};
</script>

<template>
  <div>
    <label
      class="block text-xs font-semibold text-n-slate-11 mb-1 uppercase tracking-wide"
    >
      {{ definition.attribute_display_name }}
    </label>

    <select
      v-if="type === 'list'"
      :value="value"
      class="w-full px-2 py-1.5 rounded-md text-sm bg-n-surface-1 border border-n-weak text-n-slate-12 focus:ring-2 focus:ring-n-brand cursor-pointer"
      @change="onChange"
    >
      <option value="">Selecionar...</option>
      <option
        v-for="option in definition.attribute_values || []"
        :key="option"
        :value="option"
      >
        {{ option }}
      </option>
    </select>

    <label
      v-else-if="type === 'checkbox'"
      class="flex items-center gap-2 text-sm text-n-slate-12"
    >
      <input
        type="checkbox"
        :checked="value === true"
        class="cursor-pointer"
        @change="onChange"
      />
      {{ definition.attribute_description || 'Marcado' }}
    </label>

    <input
      v-else-if="type === 'date'"
      type="date"
      :value="dateValue"
      class="w-full px-2 py-1.5 rounded-md text-sm bg-n-surface-1 border border-n-weak text-n-slate-12 focus:ring-2 focus:ring-n-brand"
      @change="onChange"
    />

    <input
      v-else
      :type="inputType"
      :value="value"
      :placeholder="definition.attribute_description || ''"
      class="w-full px-2 py-1.5 rounded-md text-sm bg-n-surface-1 border border-n-weak text-n-slate-12 focus:ring-2 focus:ring-n-brand"
      @change="onChange"
    />
  </div>
</template>
